import React from "react";

export function LegalLayout({ title, updated, children }) {
  return (
    <div className="container-pad py-12 md:py-20 max-w-4xl">
      <div className="overline">// LEGAL</div>
      <h1 className="mt-4 font-display text-4xl md:text-5xl tracking-tight">{title}</h1>
      <div className="mt-3 font-mono text-[11px] uppercase tracking-widest text-zinc-500">
        LAST UPDATED · {updated}
      </div>
      <div className="mt-10 prose-legal">{children}</div>
    </div>
  );
}

export function Section({ n, title, children }) {
  return (
    <section className="mt-10 border-t border-zinc-800 pt-8">
      <div className="flex items-baseline gap-3">
        <span className="font-mono text-signal text-sm">{String(n).padStart(2, "0")}.</span>
        <h2 className="font-display text-2xl tracking-tight">{title}</h2>
      </div>
      <div className="mt-4 space-y-4 text-zinc-300 leading-relaxed text-[15px]">{children}</div>
    </section>
  );
}
